import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "loadMore", "prevBtn", "nextBtn"]

  connect() {
    this.updateArrows()
    this.observeLastCard()
  }

  disconnect() {
    this._observer?.disconnect()
  }

  scrollLeft() {
    this.trackTarget.scrollBy({ left: -500, behavior: "smooth" })
  }

  scrollRight() {
    this.trackTarget.scrollBy({ left: 500, behavior: "smooth" })
  }

  updateArrows() {
    const track = this.trackTarget
    const atStart = track.scrollLeft <= 4
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4

    if (this.hasPrevBtnTarget) this.prevBtnTarget.style.opacity = atStart ? "0" : "1"
    if (this.hasNextBtnTarget) this.nextBtnTarget.style.opacity = atEnd  ? "0" : "1"
  }

  observeLastCard() {
    this._observer?.disconnect()
    if (!this.hasLoadMoreTarget) return

    const cards = this.trackTarget.querySelectorAll(".blog-scroll-card")
    if (!cards.length) return

    this._observer = new IntersectionObserver((entries) => {
      this.loadMoreTarget.hidden = !entries[0].isIntersecting
    }, { threshold: 0.5, root: this.trackTarget })

    this._observer.observe(cards[cards.length - 1])
  }

  async loadMore(event) {
    const btn = event.currentTarget
    const url = btn.dataset.url
    if (!url) return

    btn.textContent = "…"
    btn.style.pointerEvents = "none"

    const response = await fetch(url, { headers: { "Accept": "text/html" } })
    const html = await response.text()
    const doc = new DOMParser().parseFromString(html, "text/html")

    const newCards = doc.querySelectorAll(".blog-scroll-card")
    newCards.forEach(card => this.trackTarget.appendChild(card))

    this.trackTarget.scrollBy({ left: 500, behavior: "smooth" })

    const nextBtn = doc.querySelector("[data-blog-scroll-target='loadMore']")
    if (nextBtn && nextBtn.dataset.url) {
      btn.dataset.url = nextBtn.dataset.url
      btn.textContent = "Mehr laden →"
      btn.style.pointerEvents = ""
    } else {
      btn.remove()
      return
    }

    this.observeLastCard()
    this.updateArrows()
  }
}
